import React from 'react';
import { Button } from '@mui/material';
import TextField from 'components/FormElements/AppTextInput';
import { makeStyles } from 'tss-react/mui';
import FieldRow from 'components/FormElements/FieldRow';
import RecordView from 'components/RecordView';
import ButtonGroup from 'components/ButtonGroup';
import { Control, Controller } from 'react-hook-form';
import { TrancheFormInput } from '../useTrancheForm';

const useStyles = makeStyles()(() => ({
  marginLeftBtn: {
    marginLeft: 10,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

type Props = {
  control: Control<TrancheFormInput>;
  handleCancel: () => void;
  handelClickAdditional: () => void;
  id: string;
  buttonDisabled?: boolean;
  formDisabled?: boolean;
};

const AdditionalInformation: React.FC<Props> = ({
  control,
  handleCancel,
  handelClickAdditional,
  id,
  buttonDisabled = false,
  formDisabled = false,
}) => {
  const { classes } = useStyles();

  return (
    <RecordView>
      <FieldRow
        title="Daily summary notification list"
        informationText="Separate emails by a semi-colon"
      >
        <Controller
          control={control}
          name="additionalInfo"
          render={({ field, fieldState }) => (
            <TextField
              name="additionalInfo"
              placeholder="Enter the email addresses you wish to receive daily subscription notifications. Please separate each email with a semi-colon. e.g. 'a@a.com;b@b.com'"
              fullWidth
              onChange={(e) => field.onChange(e.target.value)}
              value={field.value}
              variant="outlined"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              multiline
              minRows={4}
              disabled={formDisabled}
            />
          )}
        />
      </FieldRow>

      {!formDisabled && (
        <ButtonGroup>
          <Button variant="outlined" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className={classes.marginLeftBtn}
            variant="contained"
            color="primary"
            disabled={buttonDisabled}
            onClick={handelClickAdditional}
          >
            {id ? 'Update' : 'Save'}
          </Button>
        </ButtonGroup>
      )}
    </RecordView>
  );
};

export default AdditionalInformation;
